import { apiClient, handleResp } from './utils';
export default {
  login(email, password) {
    return handleResp(
      apiClient().post('/users/authenticate', {
        auth: {
          email,
          password,
        },
      }),
    );
  },
  forgotPassword(email) {
    return handleResp(
      apiClient().post('password/forgot', {
        email,
      }),
    );
  },
  resetPassword(token, email, password) {
    return handleResp(
      apiClient().post('password/reset', {
        token,
        password,
        email,
      }),
    );
  },
};
